import React, { useState, useEffect } from "react";
import "./Contact.css";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // ✅ Your EmailJS IDs — fill them here
  const SERVICE_ID = "service_konebm7";
  const TEMPLATE_ID = "template_hl6ab5o";
  const PUBLIC_KEY = "IDuKLAkRbMzwSp4Yh";

  const validate = (formData) => {
    const newErrors = {};
    const name = formData.get("name").trim();
    const email = formData.get("email").trim();
    const phone = formData.get("phone").trim();
    const date = formData.get("date");
    const message = formData.get("message").trim();

    if (!name) newErrors.name = "Name is required";
    else if (name.length < 2)
      newErrors.name = "Name must be at least 2 characters";

    if (!email) newErrors.email = "Email is required";
    else if (!/^\S+@\S+\.\S+$/.test(email))
      newErrors.email = "Invalid email address";

    if (!phone) newErrors.phone = "Phone is required";
    else if (!/^\d{10,15}$/.test(phone))
      newErrors.phone = "Phone must be 10-15 digits";

    if (!date) {
      newErrors.date = "Date is required";
    } else {
      const yearStr = date.split("-")[0];

      if (!/^\d{4}$/.test(yearStr)) {
        newErrors.date = "Year must be 4 digits";
      } else {
        const selectedDate = new Date(date);
        const today = new Date(new Date().toDateString());
        const maxDate = new Date();
        maxDate.setMonth(maxDate.getMonth() + 3);

        if (selectedDate < today) {
          newErrors.date = "Date cannot be in the past";
        } else if (selectedDate > maxDate) {
          newErrors.date = "Date must be within 3 months from today";
        }
      }
    }

    if (message.length > 500)
      newErrors.message = "Message cannot exceed 500 characters";

    return newErrors;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const form = e.target;
  const formData = new FormData(form);
  const validationErrors = validate(formData);
  setErrors(validationErrors);

  if (Object.keys(validationErrors).length === 0) {
    setLoading(true);

    const templateParams = {
      name: formData.get("name"),
      email: formData.get("email"),
      phone: formData.get("phone"),
      date: formData.get("date"),
      message: formData.get("message"),
    };

    try {
      const response = await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        templateParams,
        PUBLIC_KEY
      );

      // EmailJS success response → "OK"
      if (response.status === 200 || response.text === "OK") {
        setSubmitted(true);
        form.reset();
      } else {
        alert("Failed to send email. Please try again later.");
      }

    } catch (error) {
      console.error("EmailJS Error:", error);

      // Detect quota exceeded error (very common in free tier)
      if (
        error?.text?.includes("quota") ||
        error?.text?.includes("limit") ||
        error?.message?.includes("quota")
      ) {
        alert(
          "We are experiencing a temporary issue with our email service. Please try again later."
        );
      } else {
        alert(
          "Unable to send message right now. Please try again after some time."
        );
      }

    } finally {
      setLoading(false);
    }
  }
};


  useEffect(() => {
    document.title = "Contact | Gifted Child Therapy";
  }, []);

  return (
    <section className="contact-page">
      <div className="contact-banner">
        <img src="/contactBanner.png" alt="Contact Banner" className="banner-img" />
        <h1 className="banner-title">Contact Us</h1>
      </div>

      <div className="container">
        <div className="contact-intro">
          <p>
            At <strong>The Gifted Child – Pediatric Therapy Centre</strong>, we
            understand that every child’s journey is unique. Whether you have
            questions, want to book an appointment, or just want to learn more
            about our services, we’re here to help.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <p>
              <strong>Clinic Address:</strong> Sri Mathrushree Mansion, No-15/16,
              Behind K.R. Puram RTO, Bhattarahalli, Bangalore - 560043
            </p>
            <p>
              <strong>Phone:</strong>{" "}
              <a href="tel:+919071147506">+91 9071147506</a>
            </p>
            <p>
              <strong>WhatsApp:</strong>{" "}
              <a href="https://wa.me/919071147506">+91 9071147506</a>
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:thegiftedchild.ptc@gmail.com">
                thegiftedchild.ptc@gmail.com
              </a>
            </p>

            <h3>Office Hours</h3>
            <p>
              Monday – Saturday: 9:00 AM – 6:00 PM <br /> Sunday: Closed
            </p>

            <div className="qr-code">
              <p>
                <strong>Scan to open location on your phone:</strong>
              </p>
              <img src="/qrCode.png" alt="Location QR Code" />
            </div>
          </div>

          <div className="enquiry-form">
            <h2>
              <i className="bi bi-calendar-check"></i> Book a Consultation
            </h2>

            {submitted ? (
              <div className="thank-you">
                <h3>Thank You!</h3>
                <p>
                  Your enquiry has been submitted successfully. We will get
                  back to you shortly.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} noValidate>
                <input type="text" name="name" placeholder="Your Name" required />
                {errors.name && <span className="error">{errors.name}</span>}

                <input type="email" name="email" placeholder="Your Email" required />
                {errors.email && <span className="error">{errors.email}</span>}

                <input type="tel" name="phone" placeholder="Your Phone" required />
                {errors.phone && <span className="error">{errors.phone}</span>}

                <input type="date" name="date" required />
                {errors.date && <span className="error">{errors.date}</span>}

                <textarea
                  name="message"
                  rows="4"
                  placeholder="Message / Child’s Needs"
                ></textarea>
                {errors.message && <span className="error">{errors.message}</span>}

                <button type="submit" className="btn-submit" disabled={loading}>
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
